import { FunctionComponent } from 'react';

import { AutoplayModalConnected } from '@pp/core';

import styles from './rightDrawerCell.module.css';

export const RightDrawerCellConnected: FunctionComponent = () => {
  return (
    <div className={styles.rightDrawerCell}>
      <AutoplayModalConnected />
    </div>
  );
};
